import React from "react"
import "./Experts.scss"


export default ({ children }) => {
  // return <div className="box-n">{children}</div>
  return (

    <div>

      <div className="block-header-left " style={{marginBottom:"48px"}}>
        <h3 style={{paddingBottom:"8px", marginBottom:"0px"}}>Ekspertų taryba</h3>
        <p>Susipažink su egzamino Ekspertų taryba! <br/>
          Šie savo sričių specialistai rengia egzamino klausimus ir ruošia edukacinį turinį.</p>
      </div>


      <div className="cards-list">

        <div className="card-exp">
          <div className="card_image"><img src="https://aplinkosaugosegzaminas.lrt.lt/ekspertai/Remigijus-Lapinskas.jpg"/></div>
          <div className="card_title title-white">
            <p>Lapinskas<br/> Remigijus</p>
            <p style={{fontWeight: "normal"}}>Žaliosios politikos instituto prezidentas</p>
          </div>
        </div>

        <div className="card-exp">
          <div className="card_image"><img src="https://aplinkosaugosegzaminas.lrt.lt/ekspertai/Meda-Sermuksne2.jpg"/></div>
          <div className="card_title title-white">
            <p>Šermukšnė <br/>Meda</p>
            <p style={{fontWeight: "normal"}}>VšĮ „Augalyn“ vadovė</p>
          </div>
        </div>


        <div className="card-exp">
          <div className="card_image"><img src="https://aplinkosaugosegzaminas.lrt.lt/ekspertai/Ieva-Sadauskaite.jpg"/></div>
          <div className="card_title title-white">
            <p>Sadauskaitė<br/> Ieva</p>
            <p style={{fontWeight: "normal"}}>LRT aplinkosaugos specialistė</p>
          </div>
        </div>


        <div className="card-exp">
          <div className="card_image"><img src="https://aplinkosaugosegzaminas.lrt.lt/ekspertai/Asta-Burbaite.jpg"/></div>
          <div className="card_title title-white">
            <p>Burbaitė<br/> Asta</p>
            <p style={{fontWeight: "normal"}}>VšĮ „Žaliasis taškas“ atstovė</p>
          </div>
        </div>



        <div className="card-exp">
          <div className="card_image"><img src="https://aplinkosaugosegzaminas.lrt.lt/ekspertai/Rugile-Matuseviciute.jpg"/></div>
          <div className="card_title2 title-white">
            <p>Matusevičiūtė<br/> Rugilė</p>
            <p style={{fontWeight: "normal"}}>Aplinkosaugos aktyvistė, visuomenininkė, organizacijos „Gamtos bičiuliai“ įkūrėja</p>
          </div>
        </div>


        <div className="card-exp">
          <div className="card_image"><img src="https://aplinkosaugosegzaminas.lrt.lt/ekspertai/Ricardas-Skorupskas.jpg"/></div>
          <div className="card_title title-white">
            <p>Doc. dr. Skorupskas<br/> Ričardas</p>
            <p style={{fontWeight: "normal"}}>Vilniaus universiteto geomokslų instituto mokslininkas</p>
          </div>
        </div>

        <div className="card-exp">
          <div className="card_image"><img src="https://aplinkosaugosegzaminas.lrt.lt/ekspertai/Agne-Jasinaviciute-Trakimiene.jpg"/></div>
          <div className="card_title2 title-white">
            <p>Jasinavičiūtė-Trakimienė<br/> Agnė</p>
            <p style={{fontWeight: "normal"}}>Valstybinės saugomų teritorijų tarnybos direktorė</p>
          </div>
        </div>



      </div>

    </div>

  )
}
